<template>
  <v-container grid-list-md fluid ma-3 text-xs-center>
    <v-layout justify-center wrap row>
      <v-flex xs8 v-if="!confirmed" style="max-width:550px">
        <Panel title="Reset Password">
          <v-container pa-5>
            <v-layout column wrap>
              <v-flex xs12 text-xs-center mb-3>
                Teachers enter your email address. Students please contact your teacher for help.
              </v-flex>
              <v-flex xs12 mb-4 v-if="error">
                <v-alert
                  :value="error"
                  type="error"
                  outline
                >
                  {{ error }}
                </v-alert>
              </v-flex>
              <v-flex xs12>
                <v-text-field
                  color="secondary"
                  label="Email Address"
                  v-model="username"
                  :rules="[rules.required]"
                  prepend-inner-icon="email"
                  single-line
                  outline
                  @keyup.enter="resetPassword"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 mt-1 text-xs-center>
                <v-btn
                  color="secondary"
                  style="text-transform: unset;"
                  v-on:click="resetPassword">Reset Password</v-btn>
              </v-flex>
            </v-layout>
          </v-container>
        </Panel>
      </v-flex>
      <v-flex xs8 headline ma-3 v-if="confirmed" text-xs-center>
        <Panel title="Reset Password">
          <div class="pa-5">
            Please check your email to recover your password.
            <br /><br />
            <span class="body-1">NOTE: If you do not receive it within 5 minutes, please email <a style="color:#3296f3" href="mailto:support@brainingcamp.com">support@brainingcamp.com</a> and we'll help you out.</span>
          </div>
        </Panel>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import Panel from '@/components/Panel'
import AuthenticationService from '@/services/AuthenticationService'

export default {
  data () {
    return {
      error: null,
      username: null,
      confirmed: false,
      rules: {
          required: value => !!value || 'Required.'
      }
    }
  },
  components: {
    Panel
  },
  methods: {
    async resetPassword () {
      this.error = null
      try {
        const result = await AuthenticationService.resetPassword(this.username)

        if (result) {
          this.confirmed = true;
        }
      } catch(err) {
        this.error = err.response.data.error;
      }
    }
  }
}
</script>

<style scoped>

</style>

